// src/App.js
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import Home from './Home';
import JobTable from './JobTable';
import LinkedInCompanyPage from './LinkedInCompanyPage';
import Login from './components/Login';
import Signup from './components/Signup';

function App() {
  return (
    <>
      <Navbar />
      {/* add pb-5 (or custom padding-bottom) to push content above footer */}
      <div style={{ paddingTop: '60px', paddingBottom: '4rem', minHeight: '80vh' }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/jobs" element={<JobTable />} />
          <Route path="/banks" element={<LinkedInCompanyPage />} />
          <Route path="/login"  element={<Login />} />
          <Route path="/signup" element={<Signup />} />
        </Routes>
      </div>
      <Footer />
    </>
  );
}

export default App;
